const CATEGORIES = [
  {
    key: '0',
    text: 'Any Category',
    value: '0',
  },
  {
    key: 9,
    text: 'Networking',
    value: 'networking',
  },
  {
    key: 10,
    text: 'Hardware',
    value: 'hardware',
  },
  {
    key: 11,
    text: 'MS Office',
    value: 'office',
  },
  {
    key: 12,
    text: 'Linux',
    value: 'linux',
  },
  {
    key: 13,
    text: 'Tools',
    value: 'tools',
  },
  {
    key: 14,
    text: 'Cyber Security',
    value: 'cybersec',
  },
  {
    key: 15,
    text: 'HTML',
    value: 'html',
  },
];

export default CATEGORIES;
